import { render, staticRenderFns } from "./PrescriptionFeedbacksScreen.vue?vue&type=template&id=34ca207f"
import script from "./PrescriptionFeedbacksScreen.vue?vue&type=script&lang=ts"
export * from "./PrescriptionFeedbacksScreen.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports